<template>
  <svg width="7" height="6" viewBox="0 0 7 6" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 5.5L0 0h7z" fill="#231F20" fill-rule="evenodd" />
  </svg>
</template>

<script>
export default {
  name: 'IconTriangleDown',
};
</script>

<style></style>
